import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { LogoWhite } from "../Logo/Logo";
import HeaderMainProtected from "../Header/HeaderMainProtected";


export default function PageProtectedOnboarding({
  headerImage,
  brandtext,
  headline,
  formcomp,
  content,
}) {
  const drawerWidth = 360; // Same width as OnboardingPay's cart drawer

  return (
    <>
      <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
        
        {/* --- HEADER SECTION --- */}
        <Box
          sx={{
            position: "relative",
            backgroundImage: `url(${headerImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            color: "white",
            py: { xs: 8, md: 4 },
            px: { xs: 4, md: 2 },
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: { xs: "flex-start", md: "center" },
            textAlign: { xs: "left", md: "center" },
          }}
        >
          {/* Overlay for readability */}
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              backgroundColor: "rgba(0,0,0,0.55)",
              zIndex: 1,
            }}
          />

          {/* Content inside header */}
          <Box sx={{ position: "relative", zIndex: 2, width: "100%" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: { xs: "flex-start", md: "center" },
                mb: 2,
              }}
            >
              <LogoWhite />
            </Box>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 400,
              }}
            >
              {brandtext}
            </Typography>
          </Box>
        </Box>

        {/* --- MAIN CONTENT AREA --- */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            bgcolor: "background.default",
            px: { xs: 2, md: 6 },
            py: { xs: 2, md: 4 },
          }}
        >
          <Grid container spacing={3} justifyContent="center">

               {/* Headline */}
            <Grid size={{xs:12 }}>
              <HeaderMainProtected headline={headline} specify="" />
            </Grid>



            {/* Main dynamic content */}
            <Grid size={{xs:12, md:10, lg:8, xl:6 }}>
              
              {/* Language Toggle Button*/}   
          <Grid container justifyContent="center">  
             
            </Grid>
              {content}
            </Grid>

            {/* Optional form section */}
            {formcomp && (
              <Grid size={{xs:12, md:10, lg:4 }} sx={{textAlign: "center", mt: 4,}}>
                {formcomp}
              </Grid>
            )}
          </Grid>


        </Box>

        
      </Box>
    </>
  );
}
